import { render } from "./TableUsers.vue?vue&type=template&id=36d843b0&scoped=true"
import script from "./TableUsers.vue?vue&type=script&lang=js"
export * from "./TableUsers.vue?vue&type=script&lang=js"

import "./TableUsers.vue?vue&type=style&index=0&id=36d843b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d843b0"]])

export default __exports__